import { Button, Drawer, Tooltip } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const ExpensePrint = ({
  open,
  close,
  expenseFiltered,
  totalFilteredExpense,
}) => {
  return (
    <Drawer
      onClose={close}
      open={open}
      closable={false}
      bodyStyle={{
        // border: "1px solid red",
        padding: 5,
      }}
      width={window.innerWidth > 1080 ? 1080 : "100vw"}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 10,
        }}
      >
        <div style={{ flexGrow: 1 }}></div>
        <div>
          <Tooltip title="Close">
            <Button
              //   type="dashed"
              shape="circle"
              onClick={close}
              style={{ color: "#fff", backgroundColor: "#001529" }}
              icon={<CloseOutlined />}
            />
          </Tooltip>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            maxWidth: 600,
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginBottom: 10,
          }}
        >
          {expenseFiltered.length > 0 &&
            expenseFiltered.map((data, index) => (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "column",
                }}
                key={index}
              >
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <div style={{ flexGrow: 1 }}>{data.expense_name}</div>
                  {!data.has_sub_info && (
                    <div style={{ marginBottom: 10 }}>
                      {parseFloat(data.expense_total_amount).toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}
                    </div>
                  )}
                </div>
                {data.has_sub_info &&
                  data.data.length > 0 &&
                  data.data.map((item, index2) => (
                    <div
                      key={index2}
                      style={{
                        display: "flex",
                        marginLeft: 20,
                        marginRight: 20,
                      }}
                    >
                      <div style={{ flexGrow: 1 }}>
                        {item.sub_info.description}
                      </div>
                      <div>
                        {parseFloat(item.amount).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div>
                    </div>
                  ))}
                {data.has_sub_info && (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      marginTop: 10,
                    }}
                  >
                    <div style={{ flexGrow: 1 }} />
                    <div>
                      {parseFloat(data.expense_total_amount).toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
        </div>
        <div
          style={{
            display: "flex",
            maxWidth: 600,
            width: "100%",
            borderTop: "1px solid #e5e5e5",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              marginTop: 10,
              //   flexDirection: "column",
            }}
          >
            <div style={{ flexGrow: 1 }}>Total Expense:</div>
            <div>
              {parseFloat(totalFilteredExpense).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
        </div>
      </div>
      {console.log("totalFilteredExpense: ", totalFilteredExpense)}
    </Drawer>
  );
};

export default ExpensePrint;
